import * as React from "react";
import { useCallback } from "react";
import AutoRefreshProvider from "views/components/contexts/AutoRefreshProvider";
import useViewsDispatch from "views/stores/useViewsDispatch";
import useViewsSelector from "views/stores/useViewsSelector";
import { selectJobIds } from "views/logic/slices/searchExecutionSelectors";
import { executeActiveQuery } from "views/logic/slices/viewSlice";
import { useSearchURLQueryParams } from "views/logic/NormalizeSearchURLQueryParams";
import { durationToMS } from "util/DateTime";
import useMinimumRefreshInterval from "views/hooks/useMinimumRefreshInterval";
const SearchPageAutoRefreshProvider = ({ children }) => {
  const dispatch = useViewsDispatch();
  const jobIds = useViewsSelector(selectJobIds);
  const { autoRefresh } = useSearchURLQueryParams();
  const { data: minimumRefresh, isInitialLoading: isLoadingMinimumRefresh } = useMinimumRefreshInterval();
  const minimumRefreshInterval = minimumRefresh ? durationToMS(minimumRefresh) : 0;
  const autoRefreshInterval = durationToMS(autoRefresh);
  const interval = minimumRefreshInterval > autoRefreshInterval ? minimumRefreshInterval : autoRefreshInterval;
  const refreshConfig = autoRefresh && !isLoadingMinimumRefresh ? { interval, enabled: true } : null;
  const onRefresh = useCallback(() => {
    if (!jobIds) {
      dispatch(executeActiveQuery());
    }
  }, [dispatch, jobIds]);
  return /* @__PURE__ */ React.createElement(
    AutoRefreshProvider,
    {
      key: isLoadingMinimumRefresh ? "loading" : "ready",
      defaultRefreshConfig: refreshConfig,
      onRefresh
    },
    children
  );
};
export default SearchPageAutoRefreshProvider;
